import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import i_logo from "../../assets/img/id.express.svg";
import LanguageSelector from "../LanguageSelectorButton";
import "./Layout.css";
import { Outlet, useLocation } from "react-router-dom";
import Skeleton from "../Skeleton/Skeleton";
import { useTranslation } from "react-i18next";
import { LinkOrSkeletonProps } from "../../interfaces";
import { getFooterLinks } from './Layout.constants';
import useTimer from "../../hooks/useTimer";
import {
  IdExpressApplicationCatalogItem,
  IdExpressApplicationLogo,
  inferIdExpressDeploymentEnvironment,
  loadIdExpressApplicationCatalog,
} from "@id-express/global-user-navigation";
import { dictionaryApiUrl } from "../../constants";

const Layout = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const currentYear = new Date().getFullYear();
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [applications, setApplications] = useState<IdExpressApplicationCatalogItem[]>([]);
  const isLinksLoaded = useTimer(500);
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    let active = true;

    loadIdExpressApplicationCatalog({
      dictionaryApiBaseUrl: dictionaryApiUrl,
      environment: inferIdExpressDeploymentEnvironment(window.location.origin),
    })
      .then((items) => {
        if (active) setApplications(items);
      })
      .catch(() => {
        if (active) setApplications([]);
      });

    return () => {
      active = false;
    };
  }, []);

  const handleImageLoad = () => {
    setIsImageLoaded(true);
  };

  const renderLinkOrSkeleton = (props: LinkOrSkeletonProps): JSX.Element => {
    const { isLoaded, href, text, width } = props;
    return isLoaded ? (
      <a href={href}>{text}</a>
    ) : (
      <Skeleton width={width} height="20px" animation="enabled" display="inline" />
    );
  };

  return (
    <div className="auth-background">
      
      <Container>
        <header className={isHomePage ? "auth-header auth-header-home" : "auth-header"}>
          <div className="logoext">
            {!isImageLoaded && <Skeleton width="180px" height="53px" animation="enabled" />}
            <img
              className="auth-header-logo"
              src={i_logo}
              width="180"
              height="53"
              alt="id.Express"
              onLoad={handleImageLoad}
              style={{ display: !isImageLoaded ? "none" : undefined }}
            />
          </div>
          <LanguageSelector />
        </header>
        <main>
        <div className="justify-content-center align-items-center d-flex flex-column">
          <div className={isHomePage ? "auth-card auth-card-home" : "auth-card"}>
            <Outlet context={applications} />
          </div>
        </div>
        </main>
         <footer className="py-3 my-4">
            <ul className="nav footer-applications justify-content-center pb-3 mb-3">
              {applications.map((application) => (
                <li className="nav-item" key={application.id}>
                  <a
                    aria-label={application.name}
                    className="nav-link footer-application-link"
                    href={application.href}
                    title={application.name}
                  >
                    <IdExpressApplicationLogo
                      name={application.name}
                      src={application.imageUrl}
                      imageClassName="footer-application-logo"
                      fallbackClassName="footer-application-placeholder"
                    />
                  </a>
                </li>
              ))}
            </ul>
            <p className="text-center footer-links">
              {getFooterLinks(isLinksLoaded, currentYear, currentLang, t).map((linkProps, index) => (
                <React.Fragment key={linkProps.href}>
                  {renderLinkOrSkeleton(linkProps)}
                </React.Fragment>
              ))}
            </p>
          </footer>
      </Container>
    </div>
  );
};

export default Layout;
